import React, { useEffect, useRef } from "react";

export default function BlurReload({ isDesktop, domain, refresh, sid, timeout }) {
    if (!timeout) {
        return null;
    }

    const timeoutIdRef = useRef(null);
    const refreshLink =
        typeof refresh === "object" && refresh !== null ? (isDesktop ? refresh.pc : refresh.mob) : refresh;

    if (!refreshLink) {
        return null;
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const blur = params.get("blur");

        if (blur == null) {
            const redirect = () => {
                console.log("redirect teaser");
                window.location.href = `https://${domain}/pages/${refreshLink}/?subid=${sid}`;
            };

            const onBlur = () => {
                console.log("set redirect timeout");
                timeoutIdRef.current = setTimeout(() => {
                    redirect();
                }, `${timeout}000`);
            };

            const onFocus = () => {
                if (timeoutIdRef.current) {
                    console.log("clear redirect timeout");
                    clearTimeout(timeoutIdRef.current);
                    timeoutIdRef.current = null;
                }
            };

            window.onblur = onBlur;
            window.onfocus = onFocus;

            // Clean up event listeners on unmount
            return () => {
                window.onblur = null;
                window.onfocus = null;
                if (timeoutIdRef.current) {
                    clearTimeout(timeoutIdRef.current);
                }
            };
        }
    }, [isDesktop, domain, refresh, timeout]);

    return null;
}
